import { type FC } from 'react';

interface NumberBallProps {
  number: number;
  isBonus?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  animated?: boolean;
  animationDelay?: number;
  highlight?: boolean;
}

/** 동행복권 공식 5구간 색상 시스템 */
const getBallStyle = (number: number): React.CSSProperties => {
  if (number >= 1 && number <= 10)   return { backgroundColor: '#FBBF24', color: '#92400E', boxShadow: '0 2px 8px rgba(251, 191, 36, 0.35)' };
  if (number >= 11 && number <= 20)  return { backgroundColor: '#3B82F6', color: '#FFFFFF', boxShadow: '0 2px 8px rgba(59, 130, 246, 0.35)' };
  if (number >= 21 && number <= 30)  return { backgroundColor: '#EF4444', color: '#FFFFFF', boxShadow: '0 2px 8px rgba(239, 68, 68, 0.35)' };
  if (number >= 31 && number <= 40)  return { backgroundColor: '#64748B', color: '#FFFFFF', boxShadow: '0 2px 8px rgba(100, 116, 139, 0.35)' };
  if (number >= 41 && number <= 45)  return { backgroundColor: '#22C55E', color: '#FFFFFF', boxShadow: '0 2px 8px rgba(34, 197, 94, 0.35)' };
  return { backgroundColor: '#94A3B8', color: '#FFFFFF', boxShadow: '0 2px 8px rgba(148, 163, 184, 0.35)' };
};

const sizeMap = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-9 h-9 sm:w-10 sm:h-10 text-xs sm:text-sm',
  md: 'w-11 h-11 sm:w-14 sm:h-14 text-base sm:text-lg',
  lg: 'w-14 h-14 sm:w-20 sm:h-20 text-lg sm:text-2xl',
};

const NumberBall: FC<NumberBallProps> = ({
  number,
  isBonus = false,
  size = 'md',
  animated = false,
  animationDelay = 0,
  highlight = false,
}) => {
  const ballStyle = getBallStyle(number);

  return (
    <div
      className={`
        relative flex items-center justify-center rounded-full font-bold
        ${sizeMap[size]}
        ${animated ? 'animate-ball-pop' : ''}
        ${isBonus ? 'ring-2 ring-accent-500 ring-offset-2 ring-offset-background-50' : ''}
        ${highlight ? 'ring-2 ring-primary-500 ring-offset-1 ring-offset-background-100' : ''}
      `}
      style={{
        backgroundColor: ballStyle.backgroundColor,
        color: ballStyle.color,
        boxShadow: ballStyle.boxShadow,
        animationDelay: animated ? `${animationDelay}ms` : '0ms',
        opacity: animated ? 0 : 1,
        animationFillMode: 'forwards',
      }}
    >
      <span className="relative z-10 tabular-nums">{number}</span>
    </div>
  );
};

export default NumberBall;